<div class="copilot-home-container">
    @if (isWizardOpen) {
        <app-wizard [wizard]="wizards[selectedWizardIndex]" (submitWizard)="onWizardSubmit($event)" (exitWizard)="closeWizard()"></app-wizard>
    } @else { 
    <div class="copilot-screen-header">
        <span>Hey {{ userFirstName() }}, let's plan</span><span class="copilot-screen-header-highlight"> together</span>
    </div>
    <div class="copilot-home-prompt-bar-wrapper">
        <app-copilot-prompt-bar [promptControl]="promptControl" (sendMessage)="onSendMessage($event)"></app-copilot-prompt-bar>
    </div>
    <div class="copilot-home-brand-selection" *ngIf="!isExpiredUser">
        <app-two-stage-brand-picker
            [placeholderText]="'Select brands for tailored answers'"
            [competitorSelectionText]="'Select competitors for comparison'">
        </app-two-stage-brand-picker>
    </div>
    <div class="copilot-home-wizard-tiles-container">
        <div class="alert-center-wizard"
            [matTooltip]="!hasAlertCenterPermissions ? tooltips.sideMenu.unauthorizedTab : null"
            matTooltipClass="tooltip-with-triangle">
            <app-copilot-wizard-tile
                [isExpiredUser]="isExpiredUser"
                [iconPath]="'svg/bell.svg'"
                [title]="'Alert Center'" 
                [description]="'See where your competitors are winning, and why'"
                (click)="openAlertCenter()">
            </app-copilot-wizard-tile>
        </div>
        <app-copilot-wizard-tile
            *ngFor="let wizard of wizards.slice(0, numberOfWizardTiles); let i = index"
            [isExpiredUser]="isExpiredUser"
            [iconPath]="wizard.tileSvg"
            [title]="wizard.title"
            [description]="wizard.description"
            (click)="openWizard(i)">
        </app-copilot-wizard-tile>
        <app-copilot-more-wizard-options-tile
            [isExpiredUser]="isExpiredUser"
            [description]="'See More Options'">
        </app-copilot-more-wizard-options-tile>
    </div>
    }
</div>
